import { Controller } from "@hotwired/stimulus";

// Shows the cookie banner until the visitor makes a choice. The consent store
// itself lives in the inline head script (`window.hallConsent`) so analytics
// stay blocked before this bundle has a chance to load.
export default class extends Controller {
  static targets = ["banner"];

  connect() {
    if (this._consent().status() === null) this._show();
  }

  accept() {
    this._consent().grant();
    this._hide();
  }

  decline() {
    this._consent().deny();
    this._hide();
  }

  open(event) {
    if (event) event.preventDefault();
    this._show();
  }

  _show() {
    if (this.hasBannerTarget) this.bannerTarget.classList.remove("d-none");
  }

  _hide() {
    if (this.hasBannerTarget) this.bannerTarget.classList.add("d-none");
  }

  _consent() {
    return window.hallConsent || NO_CONSENT_STORE;
  }
}

// Keeps the banner inert if the head script was stripped or failed to run.
const NO_CONSENT_STORE = Object.freeze({
  status: () => "denied",
  grant: () => {},
  deny: () => {},
});
